<template>

    <section>

           <div class="text-center">
                <small> DCP Net AB &copy; 2019</small>
            </div>

    </section>

</template>
<script>
    export default {
        data() {
            return {
            }
        }

    }
</script>
